import React from 'react';
import { useIntl } from 'react-intl';
import { styled } from '@linaria/react';
import { toggle } from 'opticks';
import { CurrencyType } from 'types/Currency';
import { Card } from '@daedalus/atlas/Card';
import ContentWrapper from '@daedalus/atlas/helpers/ContentWrapper';
import { Icon } from '@daedalus/atlas/Icon';
import { Radio } from '@daedalus/atlas/Radio';
import { Text } from '@daedalus/atlas/Text';
import { splitPopularAndOtherCurrencies } from '@daedalus/core/src/localization/business/currency';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { SearchInput } from '../../SearchInput';
import { SelectorList } from '../SelectorList/SelectorList';
const _exp = /*#__PURE__*/() => Text;
const PriceDisplayTitle = /*#__PURE__*/styled(_exp())({
  name: "PriceDisplayTitle",
  class: "pz9xjhs",
  propsAsIs: true
});
const _exp3 = /*#__PURE__*/() => Card;
const CurrencyConversionDisclaimerWrapper = /*#__PURE__*/styled(_exp3())({
  name: "CurrencyConversionDisclaimerWrapper",
  class: "c13i11gm",
  propsAsIs: true
});
const _exp5 = /*#__PURE__*/() => ContentWrapper;
const CurrencyConversionDisclaimerText = /*#__PURE__*/styled(_exp5())({
  name: "CurrencyConversionDisclaimerText",
  class: "cznqatf",
  propsAsIs: true
});
const PriceDisplayWrapper = /*#__PURE__*/styled('div')({
  name: "PriceDisplayWrapper",
  class: "p18olp8x",
  propsAsIs: false
});
const RadioGroup = /*#__PURE__*/styled('div')({
  name: "RadioGroup",
  class: "r6oekmo",
  propsAsIs: false
});
interface Props {
  isMobile?: boolean;
  value: string;
  onChange: (code: string) => void;
  currencies: CurrencyType[];
  onSearchInputFocus?: () => void;
  showPriceDisplaySetting?: boolean;
  showTotalPrices?: boolean;
  onChangePriceDisplay?: (showTotal: boolean) => void;
}
const splitPopularAndOther = (items: CurrencyType[]) => {
  const {
    currenciesList,
    popularCurrenciesList
  } = splitPopularAndOtherCurrencies(items);
  return {
    itemsList: currenciesList.filter(Boolean),
    popularItemsList: popularCurrenciesList.filter(Boolean)
  };
};
export const CurrencySelector: React.FC<Props> = ({
  isMobile = false,
  currencies,
  onChange,
  value,
  onSearchInputFocus,
  showTotalPrices,
  showPriceDisplaySetting,
  onChangePriceDisplay
}) => {
  const {
    formatMessage
  } = useIntl();
  const showPriceConversionDisclaimer = toggle('3c85ed3b-update-payment-timeline-v4', false, true);
  const renderList = (items: CurrencyType[], isSearching = false) => <>
      {showPriceConversionDisclaimer && <CurrencyConversionDisclaimerWrapper borderColorPath="border.neutral.c100" borderRadius="lg">
          <CurrencyConversionDisclaimerText padding="s300">
            <ContentWrapper paddingTop="s100">
              <Icon name="Information" colorPath="content.neutral.c600" size="sm" />
            </ContentWrapper>
            <Text variant="bodyS">
              <FormattedMessageWrapper defaultMessage="Prices will be displayed in your selected currency. The currency charged may vary, and foreign transaction fees may apply." id="priceDisplay.currencyConversionDisclaimer" />
            </Text>
          </CurrencyConversionDisclaimerText>
        </CurrencyConversionDisclaimerWrapper>}
      {showPriceDisplaySetting && !isSearching && <PriceDisplayWrapper>
          <PriceDisplayTitle variant={isMobile ? 'titleM' : 'titleL'}>
            <FormattedMessageWrapper id="priceDisplay" defaultMessage="Price display" />
          </PriceDisplayTitle>
          <RadioGroup>
            <div id="PriceDisplay--nightly">
              <Radio hasTouchArea fullWidth checked={!showTotalPrices} name={`reviewScore-any`} label={formatMessage({
            id: 'priceDisplay.nightly',
            defaultMessage: 'Nightly price incl tax & fees'
          })} onChange={() => onChangePriceDisplay?.(false)} labelSize="bodyM" />
            </div>
            <div id="PriceDisplay--total">
              <Radio hasTouchArea fullWidth checked={Boolean(showTotalPrices)} name={`reviewScore-any`} label={formatMessage({
            id: 'priceDisplay.total',
            defaultMessage: 'Total price incl tax & fees'
          })} onChange={() => onChangePriceDisplay?.(true)} labelSize="bodyM" />
            </div>
          </RadioGroup>
        </PriceDisplayWrapper>}

      <SelectorList isMobile={isMobile} items={items} value={value} onChange={onChange} getValue={item => item.code} popularItemsTitle={formatMessage({
      id: 'popularCurrencies',
      defaultMessage: 'Popular currencies'
    })} otherItemsTitle={formatMessage({
      id: 'allCurrencies',
      defaultMessage: 'All currencies'
    })} splitPopularAndOther={splitPopularAndOther} renderItem={item => <>
            <div>
              <Text variant={isMobile ? 'bodyM' : 'bodyS'} colorPath="content.neutral.c999">
                {item.displayName}
              </Text>
              <Text variant={isMobile ? 'bodyM' : 'bodyS'} colorPath={'content.neutral.c600'} translate="no">
                {item.code} {item.code !== item.symbol && <>- {item.symbol}</>}
              </Text>
            </div>
          </>} isSearching={isSearching} />
    </>;
  if (isMobile) {
    return <SearchInput items={currencies} itemMatcher={SearchInput.matchers.default(['displayName', 'code', 'symbol'])} onFocus={onSearchInputFocus}>
        {renderList}
      </SearchInput>;
  }
  return renderList(currencies);
};

require("./CurrencySelector.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./CurrencySelector.tsx");